module.exports = __webpack_public_path__ + "img/news-ads.579883fa.jpg";